import React from 'react';

const SpinnerCargando = () => {
  return (
    <div className="flex items-center justify-center h-full bg-gray-200">
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 border-4 border-t-color-primario border-b-color-secundario border-l-transparent border-r-transparent rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default SpinnerCargando;